import React from 'react';
import { connect } from 'react-redux';

class Feedspace extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      feedspaceId: props.feedspaceId,
      feedspaceTitle: props.feedspaceTitle,
    };
  }

  componentDidMount() {
    window.feedspace?.init();
  }

  callfeedspace() {
    window.feedspace?.setUserDetails({
      id: this.props.user?.id,
      name: this.props.user?.name,
      orgID: 'Equip',
    });
  }

  render() {
    return (
      <a
        className="mg-l-auto"
        onClick={() => this.callfeedspace()}
        data-feedspace={this.state.feedspaceId}
        style={{ cursor: 'pointer' }}
      >
        {this.state.feedspaceTitle}
      </a>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps())(Feedspace);
